import { render } from "./ScriptRunsList.vue?vue&type=template&id=48fd3484"
import script from "./ScriptRunsList.vue?vue&type=script&lang=js"
export * from "./ScriptRunsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__